;(function () {
    const rootEls = [...document.querySelectorAll(".campaignprogress")]

    rootEls.forEach((rootEl) => {
        setup(rootEl)
    })

    function setup(element) {
        const progressBar = element.querySelector(".progress-bar")
        const countTotal = element.querySelector(".campaignprogress-counttotal")
        const countCurrent = element.querySelector(".campaignprogress-countcurrent")

        const url = element.dataset.campaignUrl
        let timer = null

        timer = setTimeout(() => {
            check()
        }, 15000)

        async function check() {
            const response = await fetch(url)
            const json = await response.json()

            progressBar.style.width = `${json.progress}%`
            countTotal.innerText = json.all
            countCurrent.innerText = json.sent

            if (json.progress !== 100) {
                timer = setTimeout(() => {
                    check()
                }, 15000)
            }
        }

        let hidden, visibilityChange
        if (typeof document.hidden !== "undefined") {
            // Opera 12.10 and Firefox 18 and later support
            hidden = "hidden"
            visibilityChange = "visibilitychange"
        } else if (typeof document.msHidden !== "undefined") {
            hidden = "msHidden"
            visibilityChange = "msvisibilitychange"
        } else if (typeof document.webkitHidden !== "undefined") {
            hidden = "webkitHidden"
            visibilityChange = "webkitvisibilitychange"
        }
        function handleVisibilityChange() {
            if (document[hidden]) {
                clearTimeout(timer)
            } else {
                check()
            }
        }
        if (typeof document.addEventListener === "undefined" || hidden === undefined) {
            //notsupported
        } else {
            document.addEventListener(visibilityChange, handleVisibilityChange, false)
        }
    }
})()
